import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/index";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";
import "./i18n";
import "./index.css";
import tenantFallbackCss from "./tenant.module.css?raw";
import { injectAssetVars } from "./utils/injectAssetVars";
import { injectTenantFallbackCss } from "./utils/injectTenantFallbackCss";
import { injectTenantCss } from "./utils/injectTenantCss";
import { installGlobalSwipeBlock } from "./utils/installGlobalSwipeBlock";
import { publishFeatureRestrictions } from "./utils/auth/publishFeatureRestrictions";

injectAssetVars();
injectTenantFallbackCss(tenantFallbackCss);
injectTenantCss();
installGlobalSwipeBlock();
publishFeatureRestrictions();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename="/user/">
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
